import { transformAllContentItems } from "../../utils/dataTransform/library";
import { transformForLayouts } from "../../utils/dataTransform/ContentQueryWidget/library";
import { getTrendingMLDrivenItems } from "../../fetch/graphql/requests/mlDrivenItems/library";
import { getPolopolyVideoByLineupSlug } from "../../fetch/graphql/requests/video/library";
import { getVideoItemsByCategorySlugs } from "../../fetch/graphql/requests/video/library";
import { DEFAULT_SWIMLANE_LAYOUT } from "../../components/LayoutFactory/constants";
import { PLAYLIST } from "../../components/LayoutFactory/constants";
import {
    video_trending_update,
    video_trending_error,
    video_curated_playlist_update,
    video_curated_playlist_error,
    video_more_from_base_section_update,
    video_more_from_base_section_error,
} from "../../reducers/Video/reducer";

// Trending Clips
export const fetchTrendingVideos = (
    limit,
    path,
    layout = DEFAULT_SWIMLANE_LAYOUT
) => {
    return async (dispatch) => {
        try {
            const result = await getTrendingMLDrivenItems(limit);
            const cardContentItems = result?.data?.mlDrivenItems?.items;
            const transformedContentItems = cardContentItems?.length
                ? transformAllContentItems(cardContentItems)
                : [];

            const trendingVideos = transformedContentItems?.length
                ? transformForLayouts(transformedContentItems, layout, path)
                : [];

            return dispatch(video_trending_update(trendingVideos));
        } catch (error) {
            return dispatch(video_trending_error(error?.message));
        }
    };
};

// Curated Playlist
export const fetchVideoByLineup = (lineupSlug, path) => {
    return async (dispatch) => {
        try {
            const response = await getPolopolyVideoByLineupSlug(lineupSlug, 10);
            const allContentItems = response?.allContentItems?.nodes;

            if (!Array.isArray(allContentItems)) {
                throw new Error(
                    `Failed to fetch video items from lineup: "${lineupSlug}"`
                );
            }

            const contextualHeadlineSlug = lineupSlug ?? "";

            const transformedItems = transformAllContentItems(
                allContentItems,
                contextualHeadlineSlug
            );

            const layout = { name: PLAYLIST };
            const featureAttributionData = {
                instance: "News",
            };

            const playlistItems = transformForLayouts(
                transformedItems,
                layout,
                path,
                featureAttributionData
            );

            return dispatch(video_curated_playlist_update(playlistItems));
        } catch (error) {
            return dispatch(video_curated_playlist_error(error?.message));
        }
    };
};

// More From Base Section
export const fetchMoreFromBaseSection = (categorySlugs, fetchProps = {}) => {
    const { limit = 10, sourceId = "", path = "", streamType } = fetchProps;
    return async (dispatch) => {
        const numItemsToFetch = limit + 5;
        try {
            const response = await getVideoItemsByCategorySlugs(
                categorySlugs,
                numItemsToFetch,
                streamType
            );
            const allItems = response?.data?.allContentItems?.nodes ?? [];
            const filteredItems = allItems
                .filter((item) => item.sourceId !== sourceId)
                .slice(0, limit);

            const transformedItems =
                transformAllContentItems(filteredItems) ?? [];
            const cardGridItems = transformedItems?.length
                ? transformForLayouts(
                      transformedItems,
                      DEFAULT_SWIMLANE_LAYOUT,
                      path
                  )
                : [];
            return dispatch(video_more_from_base_section_update(cardGridItems));
        } catch (error) {
            return dispatch(video_more_from_base_section_error(error?.message));
        }
    };
};
